import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, DialogContainer } from 'react-md';
import cn from 'classnames';

import './SubscribeDialog.scss';

const SubscribeDialog = props => {
    const { title, buttonCloseLabel, isVisible, className, children } = props;
    const [ visible, setVisible ] = useState(isVisible); 

    // eslint-disable-next-line no-unused-vars
    const handleShow = () => {
        setVisible(true);
      };
    
    const handleHide = () => {
        setVisible(false);
      };

    // Add actions   
    const actions = [];
    actions.push(<Button flat primary onClick={handleHide}>{buttonCloseLabel}</Button>);

    const classes = cn('subscribe-dialog', { className })

    return (
      <DialogContainer
        id="subscribe-dialog"
        className={classes}
        visible={visible}
        onHide={handleHide}
        actions={actions}
        title={title}
      >
        <div className="subscribe-dialog-body">
          {children}
        </div>
      </DialogContainer>
    )
}

SubscribeDialog.propTypes = {
    isVisible: PropTypes.bool,
    title: PropTypes.string,
    buttonCloseLabel: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

SubscribeDialog.defaultProps = {
    isVisible: true,
    title: "Souscription du contrat réussi",
    buttonCloseLabel: "Fermer",
    className: undefined
}

export default SubscribeDialog
